import { css } from "styled-components";

export const formGroupWithTooltipStyles = css`
  display: grid;
  grid-template-columns:
    [start content-start] 1fr [content-end tooltip-start] fit-content(1em)
    [tooltip-end end];
  grid-column-gap: 0.25em;
`;
